import styled from 'styled-components';

export const MobileFooterWrapper = styled.div`
  display: block;
  @media (min-width: 1280px) {
    display: none;
  }
`;

/* Regular Footer */
export const RegularFooterWrapper = styled.div`
  display: none;
  @media (min-width: 1280px) {
    display: block;
  }
`;
